import { useMemo } from "react";
import { useGetDashboardGraphics, useGetPortfolios } from "./useDashboardQueries";
import { GraphicsFilterEnum } from "../../domain/entities/DashboardEntity";
import { MultiSelectDropdownOption } from "@/components/molecules/MultiSelectDropdown/MultiSelectDropdown.types";
import { FIELD_LABELS } from "../../infrastructure/DashboardConstants";

export const useDashboardGraphicsData = () => {
    // campos deshabilitados si quieres
    const DISABLED: GraphicsFilterEnum[] = [];

    // Generamos **directamente** el tipo correcto
    const graphicsOptions: MultiSelectDropdownOption<GraphicsFilterEnum>[] =
        Object.values(GraphicsFilterEnum).map((val) => ({
            value: val,
            label: FIELD_LABELS[val],
            disabled: DISABLED.includes(val),
        }));

    // el resto igual...
    const { data: dashData, isLoading, refetch } = useGetDashboardGraphics();
    const { data: portData, isLoading: portLoading } = useGetPortfolios();

    const portfolioOptions = useMemo(
        () =>
            (portData?.data ?? []).map((p) => ({
                label: p.name,
                value: p.id,
            })),
        [portData]
    );

    const dashboardGraphics = useMemo(() => dashData?.data ?? [], [dashData]);
    return {
        isLoading: isLoading || portLoading,
        portfolioOptions,
        graphicsOptions,
        dashboardGraphics,
        dashboardGraphicsRefetch: refetch,
    };
};